module.exports = __webpack_public_path__ + "static/media/reading-corner.eeaa9fe7.png";